import { EditIcon } from "lucide-react";
import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { countryOptions } from "../addPackingList/utils";
import Select from 'react-select';
import { useGetAuthUserQuery, useUpdateProfileMutation } from "../../../../services/Api";
import { toast } from "react-toastify";
import { BASE_URL_IMAGE } from "../../../../services/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loggedIn } from "../../../../redux/AuthSlice";

// import axios from "axios";

const EditProfiles = () => {
    const navigate = useNavigate();
    const auth = useSelector((data) => data?.auth);
    const [profilePic, setProfilePic] = useState(null);
    const [bannerImage, setBannerImage] = useState(null);
    const [bannerPreview, setBannerPreview] = useState(null);
    const [preview, setPreview] = useState("https://via.placeholder.com/100");
    const [selectedOptions, setSelectedOptions] = useState('');
    const { data, isLoading: userLoading } = useGetAuthUserQuery();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const [updateProfile, { isLoading: updateProfileLoading, isError, isSuccess, error }] =
        useUpdateProfileMutation();
    const {
        register,
        handleSubmit,
        setValue,
        control,
        reset,
        watch,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        if (data) {
            reset({
                firstName: data.firstName,
                lastName: data.lastName,
                nationality: data.nationality,
                phoneNumber: data.phoneNumber,
                email: data.email,
                gender: data.gender,
                description: data.description,
                backerNumber: data.backerNumber,
            });
            if (data?.profilePicture) {
                setPreview(`${BASE_URL_IMAGE}${data?.profilePicture}`);
            }
            if (data?.backgroundImage) {
                setBannerPreview(`${BASE_URL_IMAGE}${data?.backgroundImage}`);
            }
        }
    }, [data, reset]);
    const description = watch("description") || "";
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfilePic(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const onSubmit = (data) => {
        const formData = new FormData();
        // Object.keys(data).forEach((key) => formData.append(key, data[key]));
        formData.append("firstName", data.firstName);
        formData.append("lastName", data.lastName);
        formData.append("email", data.email);
        formData.append("gender", data.gender);
        formData.append("nationality", data.nationality);
        formData.append("phoneNumber", data.phoneNumber);
        formData.append("description", data.description);
        formData.append("backerNumber", data.backerNumber);
        if (profilePic) {
            formData.append("profilePicture", profilePic);
        }
        if (bannerImage) {
            formData.append("backgroundImage", bannerImage);
        }
        updateProfile({ data: formData }).unwrap()
            .then((payload) => {
                if (payload.success) {
                    toast.success("Profile updated Successfully");
                    const updatedUser = payload.data;
                    dispatch(loggedIn({ token, user: updatedUser }));
                    // if (auth?.userRole == 'ADMIN') {
                    //     navigate(`/dashboard`)
                    // } else if (auth?.userRole == 'TRAVELLER') {
                    //     // navigate('/travel-packing')
                    //     navigate('/profile')
                    // } else {
                    //     navigate('/profile')
                    // }
                    window.location.reload();

                } else {
                    toast.error(payload?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.data?.message);
            }).finally(() => {
                console.log("cloick");

            });

    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl">
                <h2 className="text-center text-2xl font-bold mb-6">Edit Profile</h2>

                {/* Profile Picture */}
                {/* <div className="flex justify-center relative mb-6">
                    <div className="relative w-24 h-24">
                        <img src={preview} alt="Profile" className="w-24 h-24 rounded-full object-cover border-4 border-yellow-300" />
                        <label htmlFor="fileUpload" className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md border cursor-pointer">
                            <EditIcon />
                        </label>
                        <input id="fileUpload" type="file" accept="image/*" className="hidden" onChange={handleImageChange} />
                    </div>
                </div> */}


                <div className="flex flex-col items-center mb-6">
                    {/* Banner Image Upload Section */}
                    <div className="w-full relative mb-4">
                        {bannerPreview ? (
                            <div className="relative">
                                <img
                                    src={bannerPreview}
                                    alt="Banner"
                                    className="w-full h-40 object-cover rounded-md border border-gray-300"
                                />
                                <label
                                    htmlFor="bannerUpload"
                                    className="absolute top-2 right-2 bg-white p-1 rounded-full shadow-md border cursor-pointer"
                                >
                                    <EditIcon />
                                </label>
                                <button
                                    type="button"
                                    onClick={() => { setBannerPreview(null); setBannerImage(null); }}
                                    className="absolute top-2 left-2 bg-red-500 text-white w-6 h-6 rounded-full p-1 text-xs shadow-md"
                                >
                                    ✕
                                </button>
                            </div>
                        ) : (
                            <div className="w-full h-40 bg-gray-200 flex items-center justify-center text-gray-500 text-sm rounded-md border-2 border-dashed border-gray-400 relative">
                                No Banner
                                <label
                                    htmlFor="bannerUpload"
                                    className="absolute bottom-2 right-2 bg-white p-1 rounded-full shadow-md border cursor-pointer"
                                >
                                    <EditIcon />
                                </label>
                            </div>
                        )}
                        <input
                            id="bannerUpload"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setBannerImage(file);
                                    setBannerPreview(URL.createObjectURL(file));
                                }
                            }}
                        />
                    </div>

                    {/* Existing Profile Image Upload Section - Unchanged */}
                    <div className="flex justify-center relative">
                        <div className="relative w-24 h-24">
                            {preview ? (
                                <>
                                    <img
                                        src={preview}
                                        alt="Profile"
                                        className="w-24 h-24 rounded-full object-cover border-4 border-yellow-300"
                                    />
                                    <label
                                        htmlFor="fileUpload"
                                        className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md border cursor-pointer"
                                    >
                                        <EditIcon />
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setPreview(null);
                                            setProfilePic(null);
                                        }}
                                        className="absolute top-1/2 -translate-y-1/2 -right-2 bg-red-500 text-white w-6 h-6 rounded-full p-1 text-xs shadow-md"
                                    >
                                        ✕
                                    </button>
                                </>
                            ) : (
                                <>
                                    <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-sm border-2 border-dashed border-gray-400">
                                        No Image
                                    </div>
                                    <label
                                        htmlFor="fileUpload"
                                        className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md border cursor-pointer"
                                    >
                                        <EditIcon />
                                    </label>
                                </>
                            )}
                            <input
                                id="fileUpload"
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={handleImageChange}
                            />
                        </div>
                    </div>
                </div>


                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">First Name</label>
                        <input
                            {...register("firstName", {
                                required: "First name is required",
                                validate: (value) => {
                                    if (value.trim() === "") return "First name cannot be blank or just spaces";
                                    if (value[0] === " ") return "First name cannot start with a space";
                                    if (value.trim().length < 2) return "First name must be at least 2 characters";
                                    if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) return "Only letters and single spaces allowed";
                                    return true;
                                },
                            })}
                            type="text"
                            onKeyDown={(e) => {
                                if (e.key === " " && e.target.selectionStart === 0) {
                                    e.preventDefault(); // block space at start
                                }
                            }}
                            className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                        />
                        {errors.firstName && <p className="text-red-500 text-xs">{errors.firstName.message}</p>}
                    </div>

                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Last Name</label>
                        <input
                            {...register("lastName", {
                                required: "Last name is required",
                                validate: (value) => {
                                    const trimmed = value.trim();
                                    if (trimmed === "") return "Last name cannot be blank or just spaces";
                                    if (trimmed.length < 2) return "Last name must be at least 2 characters";
                                    return true;
                                },
                            })}
                            onKeyDown={(e) => {
                                if (e.key === " " && e.target.selectionStart === 0) {
                                    e.preventDefault(); // block space at start
                                }
                            }}
                            type="text"
                            className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                        />
                        {errors.lastName && <p className="text-red-500 text-xs">{errors.lastName.message}</p>}
                    </div>
                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Backer Number</label>
                        <input
                            {...register("backerNumber", {
                                // validate: (value) => {
                                //     const trimmed = value.trim();
                                //     if (trimmed === "") return "Backer numbers cannot be blank or just spaces";
                                //     if (trimmed.length < 2) return "Backer numbers must be at least 2 characters";
                                //     return true;
                                // },
                            })}
                            onKeyDown={(e) => {
                                if (e.key === " " && e.target.selectionStart === 0) {
                                    e.preventDefault(); // block space at start
                                }
                            }}
                            type="text"
                            className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                        />
                        {errors.backerNumber && <p className="text-red-500 text-xs">{errors.backerNumber.message}</p>}
                    </div>

                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Nationality</label>
                        <Controller
                            name="nationality"
                            control={control}
                            rules={{ required: "Nationality is required" }}
                            defaultValue="" // Initialize as an empty string
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    options={countryOptions}
                                    isSearchable
                                    placeholder="Select Nationality"
                                    className="mt-2"
                                    classNamePrefix="react-select"
                                    value={countryOptions.find(option => option.value === field.value) || null} // Ensures correct display
                                    onChange={(selected) => {
                                        field.onChange(selected.value); // Stores only the selected value
                                    }}
                                />
                            )}
                        />
                        {/* <input {...register("nationality", { required: "Nationality is required" })} type="text" className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]" /> */}
                        {errors.nationality && <p className="text-red-500 text-xs">{errors.nationality.message}</p>}
                    </div>

                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Phone Number</label>
                        <input {...register("phoneNumber", {
                            required: "Phone number is required",
                            pattern: {
                                value: /^\+[0-9]{10,15}$/,  // starts with +, followed by 10 to 15 digits
                                message: "Invalid phone number. Include country code, e.g., +1234567890"
                            }
                        })} type="text" className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]" />
                        {errors.phoneNumber && <p className="text-red-500 text-xs">{errors.phoneNumber.message}</p>}
                    </div>

                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Email</label>
                        <input {...register("email", { required: "Email is required", pattern: { value: /\S+@\S+\.\S+/, message: "Invalid email" } })} type="email" className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]" readOnly />
                        {errors.email && <p className="text-red-500 text-xs">{errors.email.message}</p>}
                    </div>

                    <div>
                        <label className="text-black font-roboto-mono font-medium text-[13px]">Gender</label>
                        <select {...register("gender", { required: "Gender is required" })} className="w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]">
                            <option value="MALE">Male</option>
                            <option value="FEMALE">Female</option>
                            <option value="OTHER">Other</option>
                        </select>
                        {errors.gender && <p className="text-red-500 text-xs">{errors.gender.message}</p>}
                    </div>
                    <div className="col-span-2">
                        <label className="text-black font-roboto-mono font-medium text-[13px]">
                            Description
                        </label>

                        <textarea
                            {...register("description", {
                                maxLength: {
                                    value: 500,
                                    message: "Maximum 500 characters allowed",
                                },
                            })}
                            maxLength={500}
                            className="w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[100px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                        ></textarea>

                        {/* Character Counter */}
                        <div className="text-right text-xs text-gray-500 mt-1">
                            {description.length} / 500
                        </div>

                        {/* Error Message */}
                        {errors.description && (
                            <p className="text-red-500 text-xs">{errors.description.message}</p>
                        )}
                    </div>

                    <div className="col-span-2 flex justify-center mt-4">
                        <button type="submit" className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" disabled={updateProfileLoading} > {updateProfileLoading ? 'Updating' : 'Update'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditProfiles;
